import React from 'react';
import { useIntl } from '../../../util/reactIntl';

import badgeSrc from '../../../assets/ethy-verified-badge.png';

/**
 * The official "ethy Verified" hexagon mark.
 *
 * Rendered from the real brand asset so it stays pixel-consistent with the
 * rest of Ethy. Size is controlled with CSS (width/height on the passed
 * className), defaulting to a small inline badge.
 */
const VerifiedBadge = props => {
  const { className, alt } = props;
  const intl = useIntl();
  const altText =
    alt ||
    intl.formatMessage({
      id: 'LandingPage.verifiedBadge.alt',
      defaultMessage: 'ethy Verified',
    });

  return <img className={className} src={badgeSrc} alt={altText} loading="lazy" />;
};

export default VerifiedBadge;
